// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"644":"0a4b5546","997":"ba3d8504"}[chunkId] + ".chunk.js";
};